import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import { IEntityState, buildFeatureState } from '@briebug/ngrx-auto-entity';
import { Groupe } from './groupe.model';

export interface IGroupeState {
    groupe: IEntityState<Groupe>;
}

export const GROUPE = 'groupe';

export const groupeState = createFeatureSelector<IGroupeState>(
    GROUPE
);

export const { initialState: initialGroupeState, selectors, facade: groupeFacadeBase } = buildFeatureState(
    Groupe,
    GROUPE,
    groupeState
);

export function groupeReducer(state = initialGroupeState): IEntityState<Groupe> {
    return state;
}

export const groupeReducers: ActionReducerMap<IGroupeState> = {
    groupe: groupeReducer
};